<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <SearchBlock
        ref="SearchBlock"
        :school-time-table="true"
        :loading="loading"
        :prop-school-id="schoolId"
        @getSearchValue="handleGetSearchData"
      >
      </SearchBlock>
    </div>
    <div
      :style="{
        height: tableHeight + 'px',
        position: 'relative'
      }"
      class="scroll-y-430 scroll-x-430"
    >
      <Spin v-if="loading" fix>
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>Loading</div></Spin>
      <div ref="timeTable" class="time-table">
        <table>
          <thead>
            <tr>
              <th ref="specialTh" class="special-th">
                <span>日期</span>
                <br>
                <span>分类</span>
              </th>
              <th
                v-for="(item, index) in timeTable"
                :key="index"
                :style="{ background: item.isWeekend ? '#fffcf9' : '#f7f8fa' }"
                class="head-main"
                :class="{ active: selectTime == item.time }"
                @click="handleHeadClick(item)"
              >
                <div class="head-cell">
                  <span>{{ item.time }}</span>
                  <span>{{ item.name }}</span>
                </div>
              </th>
            </tr>
          </thead>
          <!-- rows -->
          <tbody>
            <tr v-for="kcItem in schoolType" :key="kcItem.value">
              <td>
                <div class="row-cell">
                  {{ kcItem.label }}
                </div>
              </td>
              <td
                v-for="(item, index) in timeTable"
                :key="index"
                :style="{ background: item.isWeekend ? '#fffcf9' : '#fff' }"
                class="block-td"
                :class="{ active: item.time == selectTime }"
              >
                <div
                  v-if="
                    judgeLoadingData(kcItem.value, item.time, update) &&
                      portOrg != 1
                  "
                  class="loading-block-mask"
                  @click="handleLoadingMask"
                ></div>
                <div
                  v-if="
                    judgeData(kcItem.value, item.time, update) && portOrg != 1
                  "
                  class="block-bg"
                  :class="{
                    active: selectBlocks[item.time + kcItem.value]
                  }"
                  @click="handleBlockClick(kcItem.value, item.time)"
                ></div>
                <div
                  v-if="
                    judgeLoadingData(kcItem.value, item.time, update) &&
                      portOrg != 1
                  "
                  class="loading-block"
                >
                  <!-- @click="handleOpenLoadingTask(kcItem.value,item.time)" -->
                  <span>调课处理中</span>
                  <Icon
                    class="loading-icon"
                    type="ios-loading"
                    size="12"
                    color="#fff"
                  ></Icon>
                </div>
                <div
                  :class="[
                    'row-cell',
                    {
                      'small-cell':
                        item.isWeekend &&
                        !judgeData(kcItem.value, item.time, update)
                    }
                  ]"
                >
                  <!-- <span
                    v-for="(x, y) in judgeData(kcItem.value, item.time, update)"
                    :key="y"
                    class="class-item"
                    @click="handleShowDetail(x, x.classroomId)"
                  >
                    {{ x.classroomName }}
                  </span> -->
                  <div
                    v-for="(x, y) in judgeData(kcItem.value, item.time, update)"
                    :key="y"
                    class="class-item"
                    @click="handleShowDetail(x, x.classroomId)"
                  >
                    <p>{{ x.classroomName }}</p>
                    <p>
                      {{ x.classTimeBegin | formatTime }} -
                      {{ x.classTimeEnd | formatTime }}
                      <span v-if="x.teachers.length" style="margin-left: 8px">{{
                        x.teachers[0]['teacherName']
                      }}</span>
                    </p>
                  </div>

                </div>
              </td>
            </tr>
            <tr>
              <td>小计（班级数）</td>
              <td v-for="(item, index) in timeTable" :key="index">
                {{ item.listLength }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <CourseDetailModal
      ref="courseDetailModal"
      :classroom-id="classroomId"
      @timeTableOpen="handleToClassTable"
    >
      <template #providerName="{ row: { providerName } }">
        <span style="font-size: 15px; font-weight: bold">
          （提供方：{{ providerName || '未知' }}）
        </span>
      </template>
      <template #class-info-date="{ row }">
        <p>上课日期：{{ editSelectRow.classDate | initDate() }}</p>
        <p>上课时间：{{ editSelectRow | initTime() }}</p>
      </template>
      <template #update-class-date="{ row }">
        <Button
          v-if="portOrg != 1"
          style="margin-right: 16px"
          @click="handleEdit"
        >修改</Button>
      </template>
    </CourseDetailModal>
    <UpdateClassDate
      ref="updateClassDateRef"
      :school-id="schoolId"
      :branch-id="courseInfo.branchId"
      :classroom-id="courseInfo.classroomId"
      :detail-id="editSelectRow.detailId"
      @on-submit-finish="onEditSubmitFinish"
    ></UpdateClassDate>
    <BatchUpdateClassDate
      ref="batchUpdateClassDateRef"
      :detail-list="detailList"
      :begin-date="beginDate"
      :begin-time="beginTime"
      :school-id="schoolId"
      :year-code="searchData.yearCode"
      :term-code="searchData.termCode"
      @on-cancel="onBatchUpdateTimeCancel"
      @on-finish="onBatchUpdateTimeFinish"
    ></BatchUpdateClassDate>
    <LoadingTask
      ref="loadingTask"
      :school-id="schoolId"
      :search-data="searchData"
      @handleSure="refreshData"
    ></LoadingTask>
  </div>
</template>
<!-- （提供方：广州市花都区青少年科技教育协会） -->
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import SearchBlock from '../assets/components/SearchBlock.vue';
import CourseDetailModal from '../assets/components/CourseDetailModal.vue';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import DragScroll from '@/utils/drag-scroll.js';
import UpdateClassDate from '../assets/components/UpdateClassDate.vue';
import BatchUpdateClassDate from './assets/components/BatchUpdateClassDate.vue';
import LoadingTask from './assets/components/LoadingTask.vue';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import {
  getWeekText,
  getDaysInMonth,
  timeToStr

} from '@/utils/utils.js';
import axios from 'axios';
export default {
  name: 'CourseSchedulCenterDivideClassTimeTableSchoolTimeTable',
  components: {
    SearchBlock,
    CourseDetailModal,
    UpdateClassDate,
    BatchUpdateClassDate,
    LoadingTask
  },
  filters: {
    initDate(date) {
      return date ? date.substring(0, 10) : '';
    },
    initTime(data) {
      return data.classTimeBegin ? `${data.classTimeBegin.substring(11, 16)} - ${data.classTimeEnd.substring(11, 16)}` : '';
    },
    formatTime(time) {
      return time ? timeToStr(time) : '';
    }
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      loading: false,
      timeTable: [], // 学校课程表
      nowDay: '', // 当前展示的当前日期
      nowWeekInfo: {
        startDate: '',
        endDate: ''
      }, // 当前展示的当前周
      classroomId: '', // 点击选中的课班id
      portOrg: -1,
      searchData: {
        classType: null,
        courseTypeKind: null,
        courseTypeId: null,
        yearCode: null,
        termCode: null
      }, // 搜索的
      schoolId: '', // 学校id
      schoolType: [
        {
          label: '午托',
          value: '22'
        },
        {
          label: '晚托',
          value: '23'
        },
        {
          label: '素质课程',
          value: '1'
        },
        {
          label: '晚修',
          value: '24'
        }
      ],

      editSelectRow: {
        detailId: ''
      },
      courseInfo: {

        branchId: '',
        classroomId: ''
      },
      selectBlocks: {}, // 选中的课程 key:  日期+类型
      detailList: [],
      beginDate: '',
      beginTime: [],
      timeMap: null,
      selectTime: '', // 点击了哪一列
      source: null,
      detailIdPosObj: {}, // 每个detailId的位置
      wutuoList: [],
      wutuoObj: {},
      wutuoObjShow: {},
      wantuoList: [],
      wantuoObj: {},
      wantuoObjShow: {},
      suzhiList: [],
      suzhiObj: {},
      suzhiObjShow: {},
      wanxiuList: [],
      wanxiuObj: {},
      wanxiuObjShow: {},
      update: 0
    };
  },
  computed: {
    ...mapState(['userInfo', 'schoolIdForState']),
    ...mapGetters(['routeTitle'])
    // timeCourseData() {
    //   return {
    //     '22': this.wutuoObj,
    //     '23': this.wantuoObj,
    //     '1': this.suzhiObj,
    //     '24': this.wanxiuObj
    //   };
    // }
  },

  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.initDate(new Date().Format('yyyy-MM'));
    this.$nextTick(() => {
      if (this.portOrg === 2) {
        this.schoolId = this.userInfo.orgId;
        // this.getNowTimeSchoolTable();
      } else {
        // this.schoolId = localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '';
        this.schoolId = this.schoolIdForState ? this.schoolIdForState : '';
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CourseSchedulCenterDivideClassTimeTableSchoolTimeTable');
    next();
  },
  activated() {
    this.$eventHub.$on('changeSchool', id => {
      this.handleChangeSchool(id);
    });
    this.initDate(this.timeMap);
    this.getNowTimeSchoolTable(this.timeMap);
  },
  mounted() {
    const timeTableRef = this.$refs.timeTable;
    timeTableRef.addEventListener('scroll', (event) => {
      const { target } = event;
      this.$refs.specialTh.style.zIndex = target.offsetTop > 0 ? 10 : 8;
    });
    new DragScroll(timeTableRef);
    this.$eventHub.$on('changeSchool', id => {
      this.handleChangeSchool(id);
    });
  },
  destroyed() {
    this.handleCancel();
    this.$eventHub.$off('changeSchool');
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    refreshData() {
      this.initDate(this.timeMap);
      this.getNowTimeSchoolTable();
    },
    handleChangeSchool(schoolId) {
      this.schoolId = schoolId;
      this.$refs.SearchBlock.handleSearch();
    },
    handleGetSearchData(data, timeMap) {
      if (this.loading) {
        return false;
      }
      // this.searchData = { ...data };
      Object.keys(this.searchData).forEach(item => {
        this.searchData[item] = data[item] ? data[item] : null;
      });
      // this.searchData.schoolId = this.schoolId;
      this.searchData.classType === '0'
        ? (this.searchData.classType = null)
        : '';
      // this.$Spin.show();
      this.loading = true;
      this.initDate(timeMap);
      this.getNowTimeSchoolTable(timeMap);
    },
    initDate(str) {
      this.selectTime = '';
      this.timeMap = str;
      const allDay = getDaysInMonth(str.substring(0, 4), str.substring(5));
      this.nowWeekInfo.startDate = allDay[0];
      this.nowWeekInfo.endDate = allDay[allDay.length - 1];
      this.wutuoList = [];
      this.wutuoObj = {};

      this.wantuoList = [];
      this.wantuoObj = {};

      this.suzhiList = [];
      this.suzhiObj = {};

      this.wanxiuList = [];
      this.wanxiuObj = {};
      this.timeTable = allDay.map((item) => {
        return {
          time: item.substring(5),
          name: getWeekText(item),
          listLength: 0,
          isWeekend:
            getWeekText(item).indexOf('六') > -1 ||
            getWeekText(item).indexOf('日') > -1
        };
      });
    },
    // 获取当前时间段的学校课表
    async getNowTimeSchoolTable() {
      const params = {
        beginDate: `${this.nowWeekInfo.startDate} 00:00:00`,
        endDate: `${this.nowWeekInfo.endDate} 23:59:59`,
        schoolId: this.schoolId
      };
      console.log('params:', params, this.searchData);
      this.handleCancel();
      const res = await courseSchedulCenter.getSchoolTimeTableApi(
        Object.assign(params, this.searchData)
      );
      this.loading = false;
      // this.$Spin.hide();
      this.onBatchUpdateTimeCancel();
      if (res.status === 200) {
        const data = res.message.reduce((pre, cur) => {
          pre = pre.concat(cur.details);
          return pre;
        }, []);
        this.dealTimeTableOriginData(data);
      }
    },
    judgeData(classType, time) {
      let list = null;
      switch (classType) {
        case '22':
          list = this.wutuoObjShow[time] ? this.wutuoObjShow[time] : null;
          break;
        case '23':
          list = this.wantuoObjShow[time] ? this.wantuoObjShow[time] : null;
          break;
        case '1':
          list = this.suzhiObjShow[time] ? this.suzhiObjShow[time] : null;
          break;
        case '24':
          list = this.wanxiuObjShow[time] ? this.wanxiuObjShow[time] : null;
          break;
        default:
          break;
      }
      return list;
    },
    // 寻找是否处于任务进行中
    judgeLoadingData(classType, time) {
      const list = this.judgeData(classType, time);
      if (!list) {
        return false;
      } else {
        const loadingList = list.filter(item => {
          return item.procSts === 2 || item.procSts === 0;
        });
        return loadingList.length > 0;
      }
    },
    // 打开调课中的任务
    handleOpenLoadingTask(classType, time) {
      const list = this.judgeData(classType, time);
      const loadingList = list.filter(item => {
        return item.procSts === 2 || item.procSts === 0;
      });
      const busiObjIds = loadingList.map(item => {
        return item.detailId;
      });
      this.$nextTick(() => {
        this.$refs.loadingTask.openLoadingModal({
          busiObjIds
        });
      });
    },
    // 对学校课表原始数据进行处理
    dealTimeTableOriginData(data) {
      for (const item of data) {
        const index = this.timeTable.findIndex((v) => {
          const key = item.classDate.substring(5, item.classDate.length - 9);
          return v.time === key;
        });
        const nameList = item.teachers.map(x => {
          return x.teacherName;
        });
        item.teacherDesc = nameList.join(',');
        item.procSts = 1;
        if (index >= 0) {
          const time = this.timeTable[index]['time'];
          // listLength
          this.timeTable[index]['listLength']++;
          let tagIndex = -1;
          console.log(item.classType, item.courseTypeKind);
          switch (item.classType === 1 ? item.classType : item.courseTypeKind) {
            case 22:
              this.wutuoList.push(item.detailId);
              this.wutuoObj[time] = this.wutuoObj[time] ? this.wutuoObj[time].concat([item]) : [item];
              tagIndex = this.wutuoObj[time].length - 1;
              break;
            case 23:
              this.wantuoList.push(item.detailId);
              this.wantuoObj[time] = this.wantuoObj[time] ? this.wantuoObj[time].concat([item]) : [item];
              tagIndex = this.wantuoObj[time].length - 1;
              break;
            case 1:
              this.suzhiList.push(item.detailId);
              this.suzhiObj[time] = this.suzhiObj[time] ? this.suzhiObj[time].concat([item]) : [item];
              tagIndex = this.suzhiObj[time].length - 1;
              break;
            case 24:
              this.wanxiuList.push(item.detailId);
              this.wanxiuObj[time] = this.wanxiuObj[time] ? this.wanxiuObj[time].concat([item]) : [item];
              tagIndex = this.wanxiuObj[time].length - 1;
              break;
            default:
              break;
          }
          this.detailIdPosObj[item.detailId] = {
            type: item.classType === 1 ? item.classType : item.courseTypeKind,
            time,
            listIndex: tagIndex
          };
        }
      }
      this.wutuoObjShow = JSON.parse(JSON.stringify(this.wutuoObj));
      this.wantuoObjShow = JSON.parse(JSON.stringify(this.wantuoObj));
      this.suzhiObjShow = JSON.parse(JSON.stringify(this.suzhiObj));
      this.wanxiuObjShow = JSON.parse(JSON.stringify(this.wanxiuObj));
      this.update++;
      this.getAllList();
    },
    // 获取所有调课任务
    getAllList() {
      const promise1 = this.getClassTasks(this.wutuoList);
      const promise2 = this.getClassTasks(this.wantuoList);
      const promise3 = this.getClassTasks(this.suzhiList);
      const promise4 = this.getClassTasks(this.wanxiuList);
      // const promises = [promise1, promise2, promise3, promise4];
      // Promise.allSettled(promises).then(res => {
      //   this.update++;
      //   let batchIds = [];
      //   // console.log('promise都加载完成了---', res, this.suzhiObj);
      //   res.forEach(item => {
      //     if (item.status === 'fulfilled') {
      //       batchIds = batchIds.concat(item.value);
      //     }
      //   });
      //   this.getTasksStatus(batchIds);
      // });
    },
    // 获取调课任务
    getClassTasks(detailIds, allData = false) {
      return new Promise(async(resolve, reject) => {
        try {
          if (detailIds.length === 0) {
            resolve([]);
            return;
          }
          const params = {
            busiCode: 2, //
            busiObjIds: detailIds, //
            schoolIdList: [this.schoolId],
            exeFlag: 1,
            procStsList: [0, 2], // 获取进行中的任务
            pageSize: 1000,
            yearCode: this.searchData.yearCode,
            termCode: this.searchData.termCode
          };
          const res = await courseSchedulCenter.getTaskIngListApi(params);
          if (res.status === 200) {
            const batchIds = [];
            res.message.forEach(item => {
              batchIds.push(item.batchProcData.batchId);
              const detailId = item.batchProcData.busiObjId;
              const { time, type, listIndex } = this.detailIdPosObj[detailId];
              switch (type) {
                case 22:
                  this.wutuoObj[time][listIndex].procSts = item.batchProcData.procSts;
                  break;
                case 23:
                  this.wantuoObj[time][listIndex].procSts = item.batchProcData.procSts;
                  break;
                case 1:
                  this.suzhiObj[time][listIndex].procSts = item.batchProcData.procSts;
                  break;
                case 24:
                  this.wanxiuObj[time][listIndex].procSts = item.batchProcData.procSts;
                  break;
              }
            });
            this.wutuoObjShow = JSON.parse(JSON.stringify(this.wutuoObj));
            this.wantuoObjShow = JSON.parse(JSON.stringify(this.wantuoObj));
            this.suzhiObjShow = JSON.parse(JSON.stringify(this.suzhiObj));
            this.wanxiuObjShow = JSON.parse(JSON.stringify(this.wanxiuObj));
            resolve(allData ? res.message : batchIds);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(err);
        }
      });
    },

    // 获取任务的进度
    async getTasksStatus(batchIds) {
      if (batchIds.length === 0) {
        return;
      }
      const params = {
        batchIds, // 任务id
        returnThreshold: 100 // 默认全部完成返回，百分比
      };
      this.source = axios.CancelToken.source();
      const res = await courseSchedulCenter.getTaskProgressApi(params, this.source.token);
      this.source = null;
      if (res.status === 200) {
        this.refreshData();
      }
    },

    // 课程详情
    onPopperShow(row, classroomId) {
      this.editSelectRow = row;
      this.classroomId = classroomId;
      this.getCourseBaseDetails(this.classroomId);
    },
    // 获取课班详情基础信息
    async getCourseBaseDetails(classroomId) {
      const params = {
        classroomId: classroomId
      };
      const res = await courseSchedulCenter.getClassPartitionDetails(params);
      if (res.status === 200) {
        this.courseInfo = res.message;
      }
    },
    // 编辑课表信息
    handleEdit() {
      this.$nextTick(() => {
        this.$refs.updateClassDateRef.handleOpen(this.editSelectRow);
      });

      console.log(this.$refs.courseDetailModal.courseInfo);
    },
    onEditSubmitFinish() {
      this.initDate(this.timeMap);
      this.$refs.courseDetailModal.close();
      this.getNowTimeSchoolTable();
    },
    // 点击展示详情弹窗
    handleShowDetail(row, classroomId) {
      // return null;
      this.editSelectRow = row;
      this.classroomId = classroomId;
      this.getCourseBaseDetails(this.classroomId);
      console.log(this.editSelectRow, this.classroomId);
      this.$nextTick(() => {
        this.$refs.courseDetailModal.open();
      });
    },
    // 点击跳转到班级课表
    handleToClassTable() {
      const { href } = this.$router.resolve({
        path: '/courseSchedulCenter/divideClassTimeTable/schoolTimeTable/classTimeTable',
        query: { classroomId: this.classroomId, schoolId: this.schoolId }
      });
      window.open(href);
    },

    // 导出-进度条
    handleCancel() {
      this.source ? this.source.cancel('取消请求') : '';
    },
    handleLoadingMask() {
      return false;
    },
    // 表头点击
    handleHeadClick(col) {
      return null;
      if (!col.list.length) {
        this.$Message.warning('该日期暂无课程');
        return null;
      }
      this.selectBlocks = {};
      this.selectTime = col.time;
      col.list.forEach(item => {
        const key = col.time + item.classType;
        if (this.selectBlocks[key]) {
          this.selectBlocks[key].push(item);
        } else {
          this.selectBlocks[key] = [item];
        }
      });
      console.log('row', col);
      this.detailList = col.list;
      this.beginDate = col.list.length ? col.list[0].classDate.substring(0, col.list[0].classDate.length - 9) : '';
      this.selectBlocks = Object.assign({}, this.selectBlocks);
      this.$refs.batchUpdateClassDateRef.handleOpen({ actionType: 2 });
    },
    // 单个框点击
    async handleBlockClick(key, time) {
      const arr = this.judgeData(key, time);
      const detailIds = arr.map(item => {
        return item.detailId;
      });
      const loadingList = await this.getClassTasks(detailIds, true);
      if (loadingList.length > 0) {
        const tagList = loadingList.map(item => {
          return item.properties.classroomName;
        });
        const productNameStr = tagList.join('、');
        this.$Modal.info({
          title: '提示',
          content: `${productNameStr}，存在调课中的任务，请重新检索后再次尝试调课操作！`
        });
        return;
      }
      const blockKey = time + key;
      if (this.selectBlocks[blockKey]) {
        delete this.selectBlocks[blockKey];
      } else {
        this.beginDate = arr[0].classDate.substring(0, arr[0].classDate.length - 9);
        this.beginTime = [arr[0].classTimeBegin.substring(11, 16), arr[0].classTimeEnd.substring(11, 16)];
        this.selectBlocks[blockKey] = arr;
        this.detailList = arr;
        this.handleCancel();
        this.$refs.batchUpdateClassDateRef.handleOpen({ actionType: 2 });
      }
      this.selectBlocks = Object.assign({}, this.selectBlocks);
    },
    onBatchUpdateTimeCancel() {
      this.selectBlocks = {};
      this.selectTime = '';
    },
    // 批量修改课表时间之后，拿到了父级任务id
    onBatchUpdateTimeFinish(upBatchId) {
      this.$nextTick(() => {
        this.$refs.loadingTask.openLoadingModal({
          upBatchIds: [upBatchId]
        });
      });
      // this.initDate(this.timeMap);
      // this.getNowTimeSchoolTable();
    }
  }

};
</script>
<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
$boderColor: rgba(0, 0, 0, 0.1);
$backgroundColor: #f7f8fa;
.page-container {
  padding: 20px;
}
.timetable-head {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  span {
    color: #488ffa;
    cursor: pointer;
  }
  .date-block {
    border: 1px solid #ccc;
    background: $backgroundColor;
    padding: 8px;
    width: 200px;
    text-align: center;
    border-radius: 4px;
    margin: 0 16px;
  }
}
.time-table {
  min-width: 100%;
  max-height: 750px;
  overflow: auto;
  table {
    // min-width: 100%;
    table-layout: fixed;
    margin-top: 12px;
    border-top: 1px solid $boderColor;
    border-left: 1px solid $boderColor;
  }

  tr td:nth-child(1) {
    background-color: $backgroundColor;
    .row-cell {
      width: 100px !important;
    }
  }
  /* 首列固定 */
  thead tr > th:first-child,
  tbody tr > td:first-child {
    position: sticky;
    left: -1px;
    z-index: 9;
  }

  /* 表头固定 */
  thead tr > th {
    position: sticky;
    top: -1px;
    left: -1px;
    z-index: 8;
  }
  th {
    padding: 15px 0;
    background-color: $backgroundColor;
    border-right: 1px solid $boderColor;
    .head-cell {
      display: flex;
      flex-direction: column;
      span + span {
        margin-top: 5px;
      }
    }
  }
  .head-main {
    cursor: pointer;
    &.active {
      background-color: rgba($color: #c3baf8, $alpha: 0.6) !important;
    }
  }
  .block-td {
    position: relative;
    &.active {
      background-color: rgba($color: #c3baf8, $alpha: 0.6) !important;
    }
    .loading-block-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      background: rgba(0, 0, 0, 0.05);
    }
    .loading-block {
      position: absolute;
      padding: 0 16px;
      height: 20px;
      left: 50%;
      top: 0;
      z-index: 11;
      transform: translateX(-50%);
      border-radius: 0 0 10px 10px;
      cursor: pointer;
      background: #488ffa;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 12px;
      }
      .loading-icon {
        animation: circletrun 1s linear infinite;
      }
      @keyframes circletrun {
        0% {
          transform: rotate(0);
        }
        50% {
          transform: rotate(0.5turn);
        }
        100% {
          transform: rotate(1turn);
        }
      }
    }
    .block-bg {
      position: absolute;
      width: 32px;
      height: 32px;
      right: 0;
      top: 0;
      background-color: #ede9f1;
      border-radius: 0 0 0 32px;
      cursor: pointer;
      &.active {
        background-color: #488ffa;
      }
      &:hover {
        background-color: #488ffa;
      }
      &.active:before {
        content: '√';
        color: #fff;
        font-size: 18px;
        right: 6px;
        top: 4px;
        position: absolute;
      }
    }
  }
  td {
    padding: 20px 15px;
    text-align: center;
    border: 1px solid $boderColor;
    .row-cell {
      display: flex;
      width: 180px;
      flex-direction: column;
      line-height: 23px;
      // span.class-item {
      //   font-size: 12px;
      // }
      // span.class-item:hover {
      //   display: inline-block;
      //   background: rgba(97, 73, 241, 0.1);
      //   color: #488ffa;
      //   cursor: pointer;
      // }
      div.class-item {
        font-size: 12px;
        background-color: #4eb68c;
        display: inline-block;
        padding: 4px 8px;
        border-radius: 1px 1px;
        margin-bottom: 6px;
        color: #fff;
        text-align: left;
      }
      div.class-item:hover {
        display: inline-block;
        background: #61abeb;
        cursor: pointer;
      }
    }
    .small-cell {
      width: 60px !important;
    }
  }
  .special-th {
    position: relative;
    width: 130px;
    span {
      position: absolute;
    }
    span:first-child {
      top: 10px;
      right: 13px;
    }
    span:last-child {
      left: 13px;
      bottom: 10px;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 1px;
      height: 143px;
      background-color: $boderColor;
      display: block;
      transform: rotate(-64deg);
      transform-origin: top;
      overflow: hidden;
    }
  }
}
// .timetable-content {
//   margin-top: 16px;
//   display: flex;
//   border: 1px solid $boderColor;
//   .timetable-item {
//     width: calc(100 / 8 * 100%);
//     .item-head {
//       background: rgba(0, 0, 0, 0.03);
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       flex-direction: column;
//       height: 60px;
//       line-height: 20px;
//     }
//     .item-content {
//       display: flex;
//       flex-direction: column;
//       justify-content: center;
//       align-items: center;
//       padding: 24px 0;
//       border-bottom: 1px solid $boderColor;
//       span {
//         display: inline-block;
//         padding: 8px;
//         background: rgba(255, 255, 255, 0);
//         cursor: pointer;
//       }
//       span:hover {
//         background: rgba(97, 73, 241, 0.1);
//         color: #488ffa;
//       }
//       span + span {
//         margin-top: 16px;
//       }
//       &:last-child {
//         border-bottom: 0;
//       }
//     }
//   }
//   .timetable-item + .timetable-item {
//     border-left: 1px solid $boderColor;
//   }
// }
</style>
